


















































































import { QuestionObjective } from '@/resource/question/question.model';
import { QuestionLanguage } from '@/resource/subject/subject.model';
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  getMainLanguage,
  getHtmlByLanguages,
} from '../question-editor/question-editor-util';

@Component({})
export default class QuestionObjectiveContainer extends Vue {
  @Prop({ required: true })
  question!: QuestionObjective;

  @Prop({ required: true })
  languages!: QuestionLanguage[];

  @Prop({ default: false })
  isWithoutAnswer!: boolean;

  @Prop({ required: true })
  answerPosition!: number;

  @Prop({ required: true })
  isExercise: boolean;

  @Prop({ required: false })
  prevSelectedAnswer: number;

  newAnswers: { value: string; isCorrect: boolean }[] = [];
  questionHtml = '';

  created() {
    if (this.isNewObjective) {
      this.getAnswersHtmls();
      this.getQuestionHtml();
    }
  }

  get selectedAnswer() {
    return this.prevSelectedAnswer || this.prevSelectedAnswer === 0
      ? this.prevSelectedAnswer
      : null;
  }

  get isNewObjective() {
    return this.question && this.question.questionJson ? true : false;
  }

  get answers() {
    const alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

    if (!this.isNewObjective) {
      return this.question.answers.map((answer, index) => {
        const { value, isCorrect } = answer;

        const status = isCorrect ? 'correct' : '';

        return {
          id: index,
          prefix: alphabets[index],
          value,
          status,
        };
      });
    } else {
      return [];
    }
  }

  get mainLanguage() {
    return getMainLanguage(this.languages);
  }

  getQuestionHtml() {
    if (this.question.questionHtmls) {
      this.questionHtml = getHtmlByLanguages(
        this.question.questionHtmls,
        this.languages,
      );
    }
  }

  getAlphabets(id: number) {
    const alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

    return alphabets[id];
  }

  getAnswersHtmls() {
    if (this.question.answerWrongHtmls) {
      this.question.answerWrongHtmls.forEach(answerWrongHtml => {
        const wrongAnswer = getHtmlByLanguages(answerWrongHtml, this.languages);

        this.newAnswers.push({
          value: wrongAnswer,
          isCorrect: false,
        });
      });
    }

    if (this.question.answerCorrectHtmls) {
      const correctAnswer = getHtmlByLanguages(
        this.question.answerCorrectHtmls,
        this.languages,
      );

      const correctAnswerIndex = this.answerPosition;

      this.newAnswers.splice(correctAnswerIndex, 0, {
        value: correctAnswer,
        isCorrect: true,
      });
    }
  }

  selectAnswer(answer: number) {
    this.$emit('selectedAnswerAdd', answer);
  }
}
